import React from 'react';

export const Support = () => (
  <div className="support__wrapper">
    <span>Підтримка користувачів:</span>
    <span>(044) 366-80-54</span>
    <a className="support__link" href="mailto:support.kyivid@kyivcity.gov.ua">support.kyivid@kyivcity.gov.ua</a>
  </div>
)